import {BIOMATCH_FAILURE_REASONS} from './biomatchFailure';
import {OCR_FAILURE_REASONS} from './ocrFailure';

export const SERVICE_UNAVAILABLE_REASON = 'service_unavailable';
export const CHECK_TIMED_OUT_REASON = 'check_timed_out';
export type ServiceFailureReason =
  | typeof SERVICE_UNAVAILABLE_REASON
  | typeof CHECK_TIMED_OUT_REASON;

const SERVICE_FAILURE_REASONS: string[] = [
  OCR_FAILURE_REASONS.serviceError,
  BIOMATCH_FAILURE_REASONS.processingFailed,
  SERVICE_UNAVAILABLE_REASON,
  CHECK_TIMED_OUT_REASON,
];

export function isServiceUnavailable(reason?: string): boolean {
  return reason === SERVICE_UNAVAILABLE_REASON;
}

export function isServiceFailure(reason?: string): boolean {
  return Boolean(reason && SERVICE_FAILURE_REASONS.includes(reason));
}
